// Non-reactive on purpose: the app only renders inside <ClerkLoaded> + <SignedIn>
// (App.tsx), so window.Clerk.user is always populated by the time this is called.
type Role = UserPublicMetadata['roles'][number]

const hasRole = (...roles: Role[]) =>
  window?.Clerk?.user?.publicMetadata?.roles?.some(role => roles.includes(role)) ?? false

export const isReadOnly = () => hasRole('CS_VIEWER')

// Restricted CS roles (CS_AGENT without manager) and the read-only CS_VIEWER
// see only Dashboard + Patients; the rest of the entity nav is hidden,
// except for the per-entity grants below.
export const hasRestrictedNav = () => (hasRole('CS_AGENT') && !hasRole('CS_MANAGER')) || isReadOnly()

// CS agents are additionally granted GPs: visible in the nav and editable.
export const canViewGPs = () => !hasRestrictedNav() || hasRole('CS_AGENT')
export const canUpdateGPs = () => canViewGPs() && !isReadOnly()

// Creating/editing FAN email templates (Messaging presets) is restricted to CS managers.
export const canManageEmailTemplates = () => hasRole('CS_MANAGER')

// The API's UPDATE_PATIENT permission (which excludes CS_PHARMACY_MANAGER) intersected with the
// roles App.tsx lets in. Narrow it in NodeAPI first — hiding a button here does not close the endpoint.
export const canUpdatePatient = () =>
  !isReadOnly() && hasRole('LEAD_PRESCRIBER', 'PHARMACIST', 'CS_MANAGER', 'CS_AGENT')

// Sending a med request back to System ID Check (EN-80) is gated by UPDATE_PATIENT.
export const canResetIdVerification = canUpdatePatient

// The API's CS_UPDATE_USERS permission intersected with the roles App.tsx lets in.
export const canChangeWhatsAppConsent = () => !isReadOnly() && hasRole('CS_MANAGER', 'CS_AGENT')
